var STORAGE_PREFIX = "formo-";
var generateStoragePrefix = function (prefix) { return "".concat(STORAGE_PREFIX).concat(prefix); };
export var SESSION_WALLET_DETECTED_KEY = generateStoragePrefix("session-wallet-detected");
export var SESSION_CURRENT_URL_KEY = generateStoragePrefix("analytics-current-url");
export var SESSION_USER_ID_KEY = generateStoragePrefix("user-id");
export var LOCAL_ANONYMOUS_ID_KEY = generateStoragePrefix("anonymous-id");
//# sourceMappingURL=base.js.map